import Util from './util';
import Log from './log';

const Tabs = (() => {
    const getBEMTabs = (el, mod) => Util.getBEM('tabs', el, mod);
    const cls = Util.cls;
    const config = {
        sel: {
            base: getBEMTabs(),
            tabContainer: getBEMTabs('tab-container'),
            tab: getBEMTabs('tab'),
            tabActive: getBEMTabs('tab', 'active'),
            tabDisabled: getBEMTabs('tab', 'disabled'),
            tabExternal: getBEMTabs('tab', 'external'),
            highlighter: getBEMTabs('highlighter'),
        },
    };
    config.tpl = {
        highlighter: `<div class="${cls(config.sel.highlighter)}"></div>`,
    };

    Tabs.autoDiscover = true;
    Tabs.els = [];

    function Tabs(el, selected = 0) {
        const self = this;

        if (isElInvalid(el)) return;

        self.el = getNodes(el);
        self.selected = {
            index: selected,
            el: null,
        };

        self._init();
    }

    Tabs.prototype._init = function () {
        const self = this;

        // init event listeners
        self.el.tab.on('click', (ev) => self.onTabSelect(ev));
        $(window).on('resize', self.updateHighlighter.bind(self));

        self.selectInitialTab();

    };

    Tabs.prototype.selectInitialTab = function () {
        const self = this;
        if (self.selected.index === -1) return;  // don't select tab if it's intentionally prevented

        // try to select a tab. Prevent selecting external and disabled tabs
        let selectedTab = null;
        for (let i = 0; i < self.el.tab.length; i++) {
            selectedTab = self.el.tab.eq(self.selected.index + i);
            if (!selectedTab.hasClass(cls(config.sel.tabExternal)) && !selectedTab.hasClass(cls(config.sel.tabDisabled))) {
                selectedTab.click();
                break;
            }
        }
    };

    /**
     * Select tab by index
     * @param index {number}
     * @param fireClickEvent {boolean}
     */
    Tabs.prototype.selectTab = function (index, fireClickEvent = true) {
        const self = this;
        let $el = self.el.tab.eq(index);
        if (fireClickEvent) $el.click();
        else self._selectTab($el);
    };

    Tabs.prototype._selectTab = function ($el) {
        const self = this;

        let clsActive = cls(config.sel.tabActive);

        // update self.selected
        self.selected.index = $el.index();
        self.selected.el = $el;

        // set active class
        self.el.tab.removeClass(clsActive);
        $el.addClass(clsActive);

        self.updateHighlighter();
    };

    Tabs.prototype.updateHighlighter = function () {
        const self = this;
        if (!self.selected || !self.selected.el) return;
        let w = self.selected.el.outerWidth(),
            l = self.selected.el.position().left + self.selected.el.parent().scrollLeft();

        // transform highlighter
        self.el.highlighter.css({
            width: w,
            transform: `translateX(${l}px)`,
        })
    };

    // ---------- CALLBACKS ----------
    Tabs.prototype.onTabSelect = function (ev) {
        const self = this;
        const $el = $(ev.currentTarget);
        if ($el.hasClass('js--disabled')) return;

        self._selectTab($el);
    };

    // ---------- STATIC HELPER ----------

    function isElInvalid(el) {
        let $el = $(el);

        if ($el.length !== 1) return console.error('Please provide exactly one element');
        if (Tabs.els.indexOf($el[0]) > -1) return console.error('EkussTabs instance already exists for element', $el[0]);
        if (!$el.hasClass(cls(config.sel.base))) return console.error('Please provide a valid base element with class', cls(config.sel.base));

        Tabs.els.push($el[0]);
        return false;
    }

    function getNodes(el) {
        const getEl = (selector) => $(els.this.find(selector));

        let els = {this: $(el)};
        els.tabContainer = getEl(config.sel.tabContainer);
        let highlighterParent = els.tabContainer.length ? els.tabContainer : els.this;
        els.highlighter = $(config.tpl.highlighter).appendTo(highlighterParent);
        els.tab = getEl(config.sel.tab);

        return els;
    }

    Tabs._autoDiscover = () => {
        $(config.sel.base).each((i, el) => {
            new Tabs(el);
        });
    };

    // autoDiscover on document ready
    $(() => {
        if (Tabs.autoDiscover) Tabs._autoDiscover();
    });

    return Tabs;
})();

export default Tabs;